import "../footer/style.css"
import styled from 'styled-components';

const Footerport = styled.footer`
    padding: 20px 20px;
    background-color: #151515;
    & .container{
        padding: 20px 0;
        border-top: 1px solid #fff;
        @media (min-width: 996px) {
          padding: 120px 0 80px;
        }
    }

    @media(min-width: 996px){
        padding: 20px;

    }

    @media(min-width: 1280px){
        padding: 20px 0px;
    }
`

function Footer(){ 
    return(
        <Footerport>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-12">
                        <div className="big__info_footer">
                            <h2>VAMOS TRABALHAR JUNTOS? </h2>
                        </div>
                        <div className="external__links">
                            <ul>
                                <li><a href="https://www.linkedin.com/in/barbxsa/" target="_blank">//LINKEDIN</a></li>
                                <li><a href="https://github.com/barbxsa" target="_blank">//GITHUB</a></li>
                                <li><a href="https://api.whatsapp.com/send?phone=5511994246251&text=Olá%2C%20Vim%20do%20seu%20portfólio%20e%20gostaria%20de%20mais%20informações." target="_blank">//WHATSAPP</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-5 offset-lg-1 col-12 align-content-lg-center">
                        <div className="big__info_footer offset-lg-2">
                           <div className="infos__contato">
                                <p>Estou sempre aberto para novas ideias e novos desafios, então se você se interessou, segue meu contato para orçamentos, propostas e demais assuntos. É só chamar:</p>
                                <ul>
                                    <li><a href="mailto:aopgabriel@gmail.com" role="link" rel="noreferrer" aria-label="E-mail">aopgabriel@gmail.com</a></li>
                                    <li><a href="https://wa.me/5511994246251" rel="noreferrer" target="_blank" role="link" aria-label="E-mail">+55 11 99424-6251</a></li>
                                </ul>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </Footerport>
    )
}
export default Footer